<script>
import Workflow from './Workflow'
import ActionTemplates from './ActionTemplates'
import FileDownload from './FileDownload'
import LZString from 'lz-string'

export default {

  mixins: [FileDownload],

  props: {
    importData: null
  },

  data() {

    let defaultImportContent = null
    if (this.importData) {
      defaultImportContent = LZString.decompressFromEncodedURIComponent(this.importData)
      this.importData = null
      this.$emit("update:importData", null)
    }

    return {
      deleteInProgress: false,

      importError: null,
      importIsLoading: false,
      importContent: defaultImportContent,
      importSuccess: false,

      exportIsLoading: false,
      exportFileName: `TestSetup-${new Date().toISOString().slice(0, 10)}`
    }
  },

  methods: {
    exportJsonFile() {
      this.exportIsLoading = true
      let jsonExport = {
        workflows: Workflow.storage.allPlain(),
        action_templates: ActionTemplates.storage.allPlain()
      }

      let filename = `${this.exportFileName}.json`
      this.download(filename, JSON.stringify(jsonExport))
      setTimeout(()=>{
        this.exportIsLoading = false
      }, 500)
    },

    performImport() {
      this.importIsLoading = true
      this.importError = null
      try {
        let json = JSON.parse(this.importContent)
        if (!json) {
          this.importError = "No content given."
        } else if (!json.workflows && !json.action_templates) {
          this.importError = "Root keys 'workflows' and 'action_templates' not found."
        } else {
          if (json.workflows) {
            Workflow.storage.mergeAll(json.workflows)
          }
          if (json.action_templates) {
            ActionTemplates.storage.mergeAll(json.action_templates)
          }
          this.importIsLoading = false
          this.importContent = null
          this.importSuccess = true
        }
      } catch (e) {
        this.importError = `${e.name}: ${e.message}`
        this.importIsLoading = false
      }
    },


    deleteData() {
      if (!confirm('Really?')) { return }
      this.deleteInProgress = true

      setTimeout(()=>{
        Workflow.storage.replaceAll([])
        ActionTemplates.storage.replaceAll([])
        WorkflowExecution.storage.replaceAll([])
        this.deleteInProgress = false
      }, 500)

    }
  },

  computed: {
    importFieldMessages() {
      if (this.importError) {
        return this.importError
      }
      if (this.importSuccess) {
        return 'Import successful!'
      }
      return "You can import previously exported JSON here. Be aware that imported data will be appended to the existing data. Records with an existing UUID will be replaced. <br/>This only affects you, others using this tool won't even notice. You may consider a backup before importing."
    }
  },

  watch: {
    importContent() {
      if (this.importSuccess && this.importContent) {
        this.importSuccess = false
      }
    }
  }

}
</script>

<template>
  <div>
    <br><br>

    <b-field horizontal label="Export JSON">
      <div class="columns">
        <div class="column">
          <b-field>
            <b-input placeholder="Provide a filename" v-model="exportFileName" expanded></b-input>
            <p class="control">
              <span class="button is-static">.json</span>
            </p>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
    </b-field>

    <b-field horizontal>
      <b-button @click="exportJsonFile" :disabled="exportIsLoading" :loading="exportIsLoading" type="is-primary" icon-left="code-braces">Save JSON file now</b-button>
    </b-field>

    <br><hr><br>

    <b-field horizontal label="Import JSON" :message="importFieldMessages" :type="{ 'is-danger': importError, 'is-success': importSuccess }">
      <b-input type="textarea" v-model="importContent"></b-input>
    </b-field>

    <b-field horizontal>
      <b-button @click="performImport" icon-left="cloud-upload-outline" :disabled="importIsLoading || deleteInProgress" :loading="importIsLoading">
        Import JSON Data
      </b-button>
    </b-field>

    <hr>

    <b-field horizontal label="Remove data" message="You can import default dataset afterwards">
      <b-button @click="deleteData" icon-left="delete-outline" :disabled="importIsLoading || deleteInProgress" :loading="deleteInProgress" type="is-danger">
        Permanently remove all workflows and templates
      </b-button>
    </b-field>

  </div>
</template>